/**
 * Page Boutique Presenter
 */
class PageBoutiquePresenter {

	constructor(sectionId) {

		this.view = new PageBoutiqueView(this, sectionId);

		/*
		 * Listeners
		 */

		$(document).on(Model.HEADER_LAST_HEIGHT_CHANGED, $.proxy(function(_event, value) {
			// set the "sticky" offset in the view
			this.view.setStickyOffset(value);
		}, this));

		/*
		 * Initialisation
		 */

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

}